"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _depCheck = _interopRequireDefault(require("../../dep-check"));

var _lunaIcon = _interopRequireDefault(require("../luna-icon"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaSystemMessage = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([{
    condition: function condition(_ref) {
      var dismissable = _ref.dismissable;
      return dismissable;
    },
    message: 'LunaSystemMessage: Use of the dismissable prop will be deprecated. Please use dismissible prop instead.',
    breakingVersion: 4
  }, {
    condition: function condition(_ref2) {
      var truncated = _ref2.truncated;
      return truncated;
    },
    message: 'LunaSystemMessage: Use of the truncated prop will be deprecated. Component can determine if truncation is needed.',
    breakingVersion: 4
  }], _objectSpread({}, props));
  var actionText = props.actionText,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      dismissable = props.dismissable,
      dismissible = props.dismissible,
      handleAction = props.handleAction,
      handleDismiss = props.handleDismiss,
      headerText = props.headerText,
      isVisible = props.isVisible,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      size = props.size,
      type = props.type,
      other = props.other,
      variant = props.variant,
      fullWidth = props.fullWidth;

  var getClassList = function getClassList() {
    var _classnames;

    var base = _config.classes.base,
        types = _config.classes.types,
        sizes = _config.classes.sizes,
        disabledClass = _config.classes.disabled,
        variants = _config.classes.variants,
        fullWidthClass = _config.classes.fullWidth;
    return (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, base, true), _defineProperty(_classnames, disabledClass, disabled), _defineProperty(_classnames, variants.inline, variant === _config.LunaSystemMessageVariants.inline), _defineProperty(_classnames, variants.toast, variant === _config.LunaSystemMessageVariants.toast), _defineProperty(_classnames, fullWidthClass, fullWidth), _defineProperty(_classnames, sizes.small, variant === _config.LunaSystemMessageVariants.toast && size === _config.LunaSystemMessageSizes.small), _defineProperty(_classnames, types.informational, type === _config.LunaSystemMessageTypes.informational), _defineProperty(_classnames, types.success, type === _config.LunaSystemMessageTypes.success), _defineProperty(_classnames, types.warning, type === _config.LunaSystemMessageTypes.warning), _defineProperty(_classnames, types.critical, type === _config.LunaSystemMessageTypes.critical), _classnames), className);
  };

  var isControlled = handleDismiss !== undefined;

  var _isVisible;

  var setVisible;

  if (!isControlled) {
    var _useState = (0, _react.useState)(isVisible);

    var _useState2 = _slicedToArray(_useState, 2);

    _isVisible = _useState2[0];
    setVisible = _useState2[1];
  } else {
    _isVisible = isVisible;
  }

  function debounce(fn, ms) {
    var _arguments = arguments,
        _this = this;

    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        fn.apply(_this, _arguments);
      }, ms);
    };
  }

  var systemMessageContentEl = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      systemMessageContentHeight = _useState4[0],
      setSystemMessageContentHeight = _useState4[1];

  (0, _react.useEffect)(function () {
    if (systemMessageContentEl.current) {
      if (!systemMessageContentHeight) {
        setSystemMessageContentHeight(systemMessageContentEl.current.scrollHeight);
      } else {
        var debouncedHandleResize = debounce(function handleResize() {
          setSystemMessageContentHeight(systemMessageContentEl.current.scrollHeight);
        }, 300);

        if (window) {
          window.addEventListener('resize', debouncedHandleResize);
          return function () {
            window.removeEventListener('resize', debouncedHandleResize);
          };
        }
      }
    }
  });

  var _handleDismiss = function _handleDismiss() {
    if (!isControlled) {
      setVisible(false);
    } else {
      handleDismiss();
    }
  };

  var icon;

  if (size !== _config.LunaSystemMessageSizes.small) {
    icon = _react["default"].createElement(_lunaIcon["default"], {
      glyph: _config.LunaSystemMessageGlyphs[type],
      className: _config.classes.icon
    });
  } else {
    icon = null;
  }

  var getContentWrapperClass = function getContentWrapperClass() {
    var contentWrapper = _config.classes.contentWrapper;
    return (0, _classnames2["default"])(contentWrapper);
  };

  var getContentClass = function getContentClass() {
    var content = _config.classes.content;
    return (0, _classnames2["default"])(content);
  };

  var getCloseButtonClass = function getCloseButtonClass() {
    var closeAction = _config.classes.closeAction;
    return (0, _classnames2["default"])(closeAction);
  };

  var closeIcon;

  if (dismissible || dismissable) {
    closeIcon = _react["default"].createElement("button", {
      className: getCloseButtonClass(),
      onClick: _handleDismiss
    }, _react["default"].createElement(_lunaIcon["default"], {
      className: _config.classes.closeActionIcon,
      glyph: "cross"
    }));
  } else {
    closeIcon = null;
  }

  var getActionClass = function getActionClass() {
    var action = _config.classes.action;
    return (0, _classnames2["default"])(action);
  };

  var getActionButtonClass = function getActionButtonClass() {
    var actionButton = _config.classes.actionButton;
    return (0, _classnames2["default"])(actionButton);
  };

  var action;

  if (variant === _config.LunaSystemMessageVariants.inline && actionText) {
    action = _react["default"].createElement("button", {
      className: getActionClass(),
      onClick: handleAction
    }, actionText);
  } else if (variant === _config.LunaSystemMessageVariants.toast && actionText) {
    action = _react["default"].createElement("button", {
      className: getActionButtonClass(),
      onClick: handleAction
    }, actionText);
  } else {
    action = null;
  }

  var getHeaderClass = function getHeaderClass() {
    var header = _config.classes.header;
    return (0, _classnames2["default"])(header);
  };

  var header;

  if (headerText) {
    header = _react["default"].createElement("h3", {
      className: getHeaderClass()
    }, headerText);
  }

  var getInputVisibilityClass = function getInputVisibilityClass() {
    var inputVisibility = _config.classes.inputVisibility;
    return (0, _classnames2["default"])(inputVisibility);
  };

  var getLabelVisibilityClass = function getLabelVisibilityClass() {
    var labelVisibility = _config.classes.labelVisibility;
    return (0, _classnames2["default"])(labelVisibility);
  };

  var inputVisibility;
  var labelVisibility;

  if (systemMessageContentHeight > 50) {
    var inputLabelId = _lodash["default"].uniqueId('show-hide');

    inputVisibility = _react["default"].createElement("input", {
      className: getInputVisibilityClass(),
      id: inputLabelId,
      type: "checkbox"
    });
    labelVisibility = _react["default"].createElement("label", {
      className: getLabelVisibilityClass(),
      htmlFor: inputLabelId
    });
  }

  var childrenSection = typeof children === 'string' ? _react["default"].createElement("p", null, children) : children;
  var content;

  if (variant === _config.LunaSystemMessageVariants.inline) {
    content = _react["default"].createElement("div", {
      className: getContentWrapperClass()
    }, header, inputVisibility, _react["default"].createElement("div", {
      className: getContentClass(),
      ref: systemMessageContentEl
    }, childrenSection), labelVisibility, action);
  } else {
    content = _react["default"].createElement("div", {
      className: getContentClass(),
      ref: systemMessageContentEl
    }, childrenSection, action);
  }

  return _react["default"].createElement(_react["default"].Fragment, null, _isVisible && _react["default"].createElement("aside", _extends({}, other, {
    className: getClassList(),
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart
  }), icon, content, closeIcon));
});

LunaSystemMessage.propTypes = {
  actionText: _propTypes["default"].string,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  dismissable: _propTypes["default"].bool,
  dismissible: _propTypes["default"].bool,
  handleAction: _propTypes["default"].func,
  handleDismiss: _propTypes["default"].func,
  headerText: _propTypes["default"].string,
  isVisible: _propTypes["default"].bool,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  size: _propTypes["default"].oneOf(Object.values(_config.LunaSystemMessageSizes)),
  truncated: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(Object.values(_config.LunaSystemMessageTypes)),
  variant: _propTypes["default"].oneOf(Object.values(_config.LunaSystemMessageVariants))
};
LunaSystemMessage.defaultProps = {
  isVisible: true,
  other: {}
};
LunaSystemMessage.displayName = 'LunaSystemMessage';
var _default = LunaSystemMessage;
exports["default"] = _default;
